module.exports = __webpack_public_path__ + "static/media/gnosjovapen.bcff89d3.png";